module.exports = __webpack_public_path__ + "static/media/ArrowUp.bf0d475e.svg";